import * as constants from '../../constants';
import * as checkbox from '../../shared-ui/checkbox';
import selectionButton from './selection-button';
import sectionTitle from '../../shared-ui/section-title';
import sectionBody from '../../shared-ui/section-body';
import Stepper from '../../shared-ui/stepper';
import startButton from './start-button';
import { generateAndStartNewTest } from '../../app';

export const introScreen = new PIXI.Container();
introScreen.visible = false;

const ttSectionTitle = sectionTitle('SELECT YOUR TIMES TABLES');
introScreen.addChild(ttSectionTitle);

const ttSectionBody = sectionBody(230);
introScreen.addChild(ttSectionBody);
ttSectionBody.position.set(0, constants.headerHeight);

const cbHPadding = 27;
const cbOuterWidth = checkbox.width + cbHPadding;
const cols = 6;

const cbGroup = new PIXI.Sprite();
ttSectionBody.addChild(cbGroup);
cbGroup.anchor.set(0.5, 0);
cbGroup.position.set(constants.screenCentreX, 20);

const data = [];
for ( var i = 0; i < 12; i++ ) {
  data[ i ] = {
    selected: true,
    value: i + 1
  };
  const cb = checkbox.create(data[ i ], introScreen);
  const col = i % cols;
  const row = Math.floor(i / cols);
  const x = cbOuterWidth * ( col - ( cols - 1 ) / 2 );
  const y = 73 * row;
  cb.position.set(x, y);
  cbGroup.addChild(cb);
}

const ttButtons = new PIXI.Sprite();
ttSectionBody.addChild(ttButtons);
ttButtons.anchor.set(0.5, 0);
ttButtons.position.set(constants.screenCentreX, 73 * 2 + 40);

const selectAll = selectionButton(true, data, introScreen);
ttButtons.addChild(selectAll);
selectAll.position.set(-80, 0);

const clear = selectionButton(false, data, introScreen);
ttButtons.addChild(clear);
clear.position.set(80, 0);

const numQsSectionTitle = sectionTitle('SELECT THE QUIZ LENGTH');
introScreen.addChild(numQsSectionTitle);
numQsSectionTitle.position.set(0, 305);

const numQsSectionBody = sectionBody(150);
introScreen.addChild(numQsSectionBody);
numQsSectionBody.position.set(0, 355);

const numQsContainer = new PIXI.Container();
numQsSectionBody.addChild(numQsContainer);

const stepper = new Stepper(5, 50, 5, 10);
numQsContainer.addChild(stepper.sprite);

const qsText = new PIXI.Text('QUESTIONS', {
  font: '24px Open Sans, Arial',
  fill: 0xFFFFFF,
  align: 'center',
  letterSpacing: 2
});
numQsContainer.addChild(qsText);
qsText.anchor.set(0, 0.5);

stepper.sprite.x = 25; // left-aligns
qsText.x = 70; // width of stepper: 50 + spacing: 20
const totalWidth = 70 + qsText.width;
numQsContainer.position.set(constants.screenCentreX - totalWidth / 2, 70);

const startBtn = startButton(data, introScreen);
introScreen.addChild(startBtn);
startBtn.position.set(constants.screenCentreX, 565);

startBtn.on('pointerdown', () => {
  const tts = data.filter(o => o.selected).map(o => o.value);
  generateAndStartNewTest({ timestables: tts, numQuestions: stepper.value });
});
